<template>
  <div>
    <ul>
      <li
        v-for="(item, index) in newsList"
        :key="index"
        class="news_item"
        @click="fnToArticle(item.article_id)"
      >
        <el-image :src="item.main_image[0]" fit="cover"></el-image>
        <div class="news_item_info">
          <h3>{{ item.title }}</h3>
          <div class="news_item_time">
            <div>{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}</div>
            <div class="el-icon-view">{{ item.times }}</div>
          </div>
          <div class="news_item_desc" v-if="item.desctext">
            {{ item.desctext }}
          </div>
        </div>
      </li>
    </ul>
    <el-button type="info" @click="fnToGetMore">點擊加載更多</el-button>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  data(){
    return{
      newsListRes:[],
      start: 0,
      limit: 10,
    }
  },
  computed:{
    ...mapState(['user_id']),
    newsList(){
      return this.newsListRes.map(item=>{
        // item.main_image = JSON.parse(item.main_image);
        // item.main_image = item.main_image.map(img => !/^http/.test(img) ? this.$imgUrl + img : img);
        try{
          if(item.show_type != 0&&item.main_image!=1&&item.main_image) {
            // alert(item.main_image)
            item.main_image = JSON.parse(item.main_image);
            item.main_image = item.main_image.map(img => !/^http/.test(img) ? this.$imgUrl + img : img);
            
          }
        } catch(e){
          // alert(JSON.stringify(e))
          // alert('數據異常，請稍後重試');
        }
        // // console.log(item.main_image)

        return item; 
      });
    }
  },
  watch:{
    user_id(val){
      this.getNewsList()
    }
  },
  methods:{
    async getNewsList() {
      const { data: res } = await this.$http.get(`/api/v2/article/favouriteList/${this.user_id}/1`, {
        params: {
          start: this.start,
          limit: this.limit,
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.newsListRes =[...this.newsListRes, ...res.data]
      if(res.data.length==0){
      this.$message.success('暫無更多')
      }
      setTimeout(()=>{
        this.$zhTran()
      },300)
    },
    fnToArticle(article_id){
      // console.log(article_id)
      this.$router.push({
        path: `/article/${article_id}`,
      })
    },
    fnToGetMore(){
      this.start += this.limit;
      this.getNewsList()
    },
  },
  mounted() {
    if(this.user_id){
      this.getNewsList()
    }
  },
}
</script>

<style lang="less" scoped>
.news_item {
  padding-bottom: 30px;
  display: flex;
  align-items: center;
  margin-left: 30px;
  cursor: pointer;
  .el-image {
    width: 200px;
    height: 120px;
    margin-right: 26px;
  }
  .news_item_info {
    // margin-top: 8px;
    flex: 1;
    h3 {
      font-size: 22px;
      line-height: 34px;
      color: #000;
      margin-bottom: 18px;
    }
    .news_item_time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: #333333;
      margin-right: 27px;
    }
    .news_item_desc {
      font-size: 14px;
      color: #414141;
      line-height: 22px;
      margin-top: 23px;
    }
    .el-icon-view:before {
      margin-right: 5px;
    }
  }
}
.el-button {
  width: 100%;
  font-size: 14px;
  color: #878787;
  line-height: 22px;
  padding: 10px 0;
  background: #fbfbfb;
  border: none;
  margin-bottom: 10px;
}

@media screen and (max-width: 768px){
  .news_item{
    padding: 5px 20px;
    margin-left: 0;
    .el-image {
      width: 120px;
      height: 75px;
      margin-right: 12px;
      border-radius: 8px;
    }
    .news_item_info {
      h3 {
        font-size: 16px;
        line-height: 28px;
        color: #000;
        margin-bottom: 5px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .news_item_time {
        font-size: 12px;
        color: #333333;
        margin-right: 10px;
      }
    }
  }
  .el-button {
    width: 80%;
    font-size: 14px;
    color: #878787;
    line-height: 22px;
    padding: 10px 0;
    background: #fbfbfb;
    border: none;
    margin: 10px auto;
    display: block;
  }
}
</style>
